import React, { ReactNode } from 'react';
import { SpriteImage } from '../..';
import styles from './toastmessage.module.scss';

interface IToastMessageProps {
    isShown: boolean;
    children: ReactNode;
}

export const ToastMessage = (props: IToastMessageProps): JSX.Element => {
    return (
        <div className={[styles.toastMessage, props.isShown ? styles.shown : ''].join(' ')}>
            <SpriteImage className={styles.icon} />
            <div>{props.children}</div>
        </div>
    );
};
